<script setup lang="ts">
import type { BlogT } from '~/schema/types'

const featured = ref<BlogT[]>()
const active = useState('blog-state', () => '')
const props = defineProps<{
  category?: string
}>()
onMounted(() => {
  $fetch<BlogT[]>('/intl-api/blogs/featured', {
    params: {
      category: props.category
    }
  }).then((res) => {
    featured.value = res ?? []
  })
})
</script>
<template>
  <section class="py-6 lg:py-10">
    <UiContainer>
      <p class="text-lg lg:text-xl font-inter font-semibold lg:py-4">
        Terpopuler
      </p>
      <div class="grid lg:grid-cols-3 gap-3 lg:gap-5">
        <template v-if="featured?.length">
          <UiCardBlog
            v-for="(blog, index) in featured"
            :key="blog.slug + index"
            :blog="blog"
            :class="{
              active: active === blog.id + index + 'featured'
            }"
            @mouseenter="active = blog.id + index + 'featured'"
          />
        </template>
        <template v-else>
          <UiCardBlogSkeleton v-for="n in 6" :key="n" />
        </template>
      </div>
    </UiContainer>
  </section>
</template>
